import { render, staticRenderFns } from "./dictDialog.vue?vue&type=template&id=f0b090a8&scoped=true"
import script from "./dictDialog.vue?vue&type=script&lang=js"
export * from "./dictDialog.vue?vue&type=script&lang=js"
import style0 from "./dictDialog.vue?vue&type=style&index=0&id=f0b090a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b090a8",
  null
  
)

export default component.exports